<template>
    <div>
        <loadingComponent @closeDialog="dialog = $event" v-if="dialog" :dialogProps="dialog" :loadingProps="loading"
            :errorProps="error" />
        <v-dialog v-model="dialogAddCompteur" persistent width="1250" min-height="250">
            <v-card>
                <v-toolbar :color="$colors[0]" dark>
                    <v-card-title class="text-h6">
                        Edition contrat GEG Gaz
                    </v-card-title>
                </v-toolbar>

                <v-form ref="form" lazy-validation v-if="ajouterUnAutreCompteur == true">
                    <v-card-actions class="d-flex flex-row">
                        <div class="d-flex flex-column">
                            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                <p><b>N° Compteur selectionné:</b> <small>{{ numCompteur }}</small></p>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                <v-autocomplete v-model="selectedCompteur" :items="listCompteurResult"
                                    :loading="isLoading" hide-no-data hide-selected label="Autre compteur"
                                    placeholder="Ajouter un compteur" prepend-icon="mdi-account-search-outline" chips
                                    item-text="numCompteur" item-value="numCompteur" deletable-chips multiple
                                    return-object clearable>
                                    <template v-slot:selection="{ item, index }">
                                        <v-chip v-if="index === 0">
                                            <span>{{ item.numCompteur }}</span>
                                        </v-chip>
                                        <span v-if="index === 1" class="grey--text text-caption">
                                            (+{{ selectedCompteur.length - 1 }} {{ selectedCompteur.length - 1 > 1 ?
                                                'éléments' : "élément" }})
                                        </span>
                                    </template>
                                    <template v-slot:item="data">
                                        <template>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ data.item.numCompteur }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                    <template v-slot:prepend-item>
                                        <v-list-item ripple @click="toggle">
                                            <v-list-item-content>
                                                <v-list-item-title>Select All</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </div>
                    </v-card-actions>
                </v-form>
                <v-col>
                    <div class="d-flex flex-column ma-4">
                        <div class="d-flex flex-row justify-end">
                            <v-btn color="error" text @click="closeModal">Fermer</v-btn>
                            <v-btn :color="$colors[0]" class="white--text" @click="createContrat">
                                Generer contrat
                                <v-icon dense class="ml-2">mdi-file-upload</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-card>
        </v-dialog>

        <div>
            <v-btn v-if="donner.typeFournisseur !== 'AuFrn' && donner.typeFournisseur != 'Actuelle'"
            @click="openDialog"
            icon
            depressed class="ma-auto text-capitalize">
                <v-icon  :color="$colors[0]">mdi-text-box-edit</v-icon>
            </v-btn>
        </div>
    </div>
</template>
<script>
import loadingComponent from "../../components/ui/loading-component.vue"
import { PDFDocument } from 'pdf-lib'
import download from 'downloadjs'
import axios from 'axios'
export default {
    name: 'GEGGAZ',
    components: { loadingComponent },
        props: {
            donner: null,
            numCompteur: null,
            societe: null,
            donnerEnedis: null,
            listCompteur: {
                type: Array,
                default: () => [],
            },
            donnerCompteurs: {
                type: Array,
                default: () => [],
            },
        },
        data: () => ({
            dialog: false,
            error: false,
            loading: false,
            dialogAddCompteur: false,
            ajouterUnAutreCompteur: false,
            isLoading: false,
            selectedCompteur: [],
            listCompteurResult: [],
        }),
        methods:{
            prepareCompteurs() {
                // Build the list of other GEG gaz compteurs available for this société, excluding the current one
                this.listCompteurResult = this.donnerCompteurs
                    .filter(cpt => {
                        return this.listCompteur.includes(cpt.NumCompteur) &&
                            cpt.NumCompteur !== this.numCompteur;
                    })
                    .map(cpt => {
                        const gegOffer = cpt.resultat.result.find(offer =>
                            offer.fournisseur === "GEG"
                        );
                        return {
                            ...gegOffer,
                            numCompteur: cpt.NumCompteur,
                            societe: cpt.resultat.dataSociete,
                            donnerEnedis: cpt.resultat.dataEnedis,
                        };
                    });
            },
            toggle() {
                this.selectedCompteur = [...this.listCompteurResult]
            },
            openDialog() {
                this.dialogAddCompteur = true
                this.ajouterUnAutreCompteur = true
                this.prepareCompteurs();
            },
            closeModal() {
                this.dialogAddCompteur = false
                this.ajouterUnAutreCompteur = false
                this.selectedCompteur = []
            },
            supprimerCompteur(numComp) {
                const index = this.selectedCompteur.findIndex(x => x.numCompteur === numComp);
                if (index > -1) {
                    this.selectedCompteur.splice(index, 1);
                }
            },
            // Builds the exact same payload shape sent to the mono-site endpoint,
            // for a given compteur/offer. Reused for both the mono call and each
            // entry of the multi-site call's list, so every compteur in a multi
            // contract carries the same full set of data as a standalone one.
            buildContractPayload(offer, numCompteur, societe, donnerEnedis) {
                return {
                    company: {
                        raison: societe.Raison,
                        siret: societe.siret,
                        full_address: societe.AdressePostal || '',
                        naf_code: societe.codeNaf || '',
                    },
                    contract: {
                        start_date_fourniture: offer.dateDebut,
                        end_date_fourniture: offer.dateFin,
                        duree: offer.DUREE,
                        type_prix: offer.Offre || '',
                        prix_fourniture: offer.prixMolucule,
                        cee: offer.cee,
                        cpb: offer.CPB,
                        surcout_biogaz: offer.prixBio ?? '',
                    },
                    vendeur: {
                        nom: localStorage.getItem('vendeurName'),
                        email: localStorage.getItem('email'),
                        telephone: localStorage.getItem('Telephone'),
                    },
                    signataire: {
                        fullname: `${societe.nom || ''} ${societe.prenom || ''}`.trim(),
                        fonction: societe.fonction || 'Gerant',
                        telephone: societe.numTele || '',
                        email: societe.AdresseEmail || '',
                    },
                    compteur: {
                        pdl: numCompteur,
                        address: societe.AdressePostal || '',
                        grd: donnerEnedis?.grd || '',
                        annual_consumption_mwh: offer.consomationGlobale,
                        tarif: offer.typeCompteur || '',
                        profil: offer.profilCompteur || '',
                    },
                    courtier: 'Gaz Elec Moins Cher',
                }
            },
            async createContrat(){
                this.dialog = true
                this.error = false
                this.loading = true

                const primaryPayload = this.buildContractPayload(this.donner, this.numCompteur, this.societe, this.donnerEnedis)

                let urlCall = 'contracts/GegGazContractView'
                let dataToSend = primaryPayload
                if (this.selectedCompteur.length > 0) {
                    urlCall = 'contracts/GegGazMultiSiteContractView'
                    dataToSend = {
                        listCompteur: [
                            primaryPayload,
                            ...this.selectedCompteur.map(offer =>
                                this.buildContractPayload(offer, offer.numCompteur, offer.societe || this.societe, offer.donnerEnedis || this.donnerEnedis)
                            ),
                        ],
                    }
                }

                try {
                    const response = await axios({
                        url: process.env.VUE_APP_URL_EDITION_CONTRACT_V2 + urlCall,
                        method: 'POST',
                        data: dataToSend,
                        headers: { 'content-type': 'application/json' },
                        responseType: 'blob',
                    })

                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    })
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = `${this.numCompteur}_GegGaz_${this.societe.Raison}_.docx`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(link.href)

                    const url0 = '/pdf/geg/CGV_GEG_GAZ.pdf'
                    const pageZero = await fetch(url0).then((res) => res.arrayBuffer())
                    const pageZeroDoc = await PDFDocument.load(pageZero)
                    const pdfBytes = await pageZeroDoc.save()
                    download(pdfBytes, 'CGV_GEG.pdf', 'application/pdf')
                } catch (err) {
                    console.log(err)
                    this.error = true
                }

                this.dialogAddCompteur = false
                this.ajouterUnAutreCompteur = false
                this.selectedCompteur = []
                this.dialog = false
                this.loading = false
            },
        }
    }
</script>
<style>
#tableau-edition-ekwateur.table-bordered thead th {
    background-color: #07a4ca;
    color: white;
    font-weight: bold;
}
</style>
